import { createFileRoute } from "@tanstack/react-router";
import UkPrivacy from "@/pages/legal/UkPrivacy";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/privacy/")({
  head: () => routeHead("/uk/privacy/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkPrivacy />
  );
}
